import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import NewRetainerClientAssignmentDiscussionTopicCommentForm from '../forms/NewRetainerClientAssignmentDiscussionTopicCommentForm';

class DiscussionTopic extends Component {
  state = {};

  render() {
    const { topic, refetchQuery } = this.props;
    const { description, comments } = topic;
    return (
      <div>
        <p>{description}</p>
        <div style={{ padding: 15, margin: '15px 0', maxHeight: 600, overflowY: 'auto' }}>
          {comments ? (
            comments.map((entry, index) => (
              <div
                key={entry.id}
                style={{
                  borderBottom: '1px dashed #AAA',
                  padding: '15px 5px',
                  borderTop: index === 0 ? '1px dashed #AAA' : 'none',
                }}
              >
                <p style={{ marginBottom: 5 }}>
                  <strong style={{ color: '#000' }}>{entry.commentBy}</strong>
                  <span style={{ marginLeft: 10, fontSize: '0.8rem', color: '#999' }}>
                    {moment(entry.commentedAt).fromNow()}
                  </span>
                </p>
                <p style={{ margin: 0 }}>{entry.comment}</p>
              </div>
            ))
          ) : (
            <p>No comments!</p>
          )}
        </div>
        <NewRetainerClientAssignmentDiscussionTopicCommentForm
          discussionTopicId={topic.id}
          refetchQuery={refetchQuery}
        />
      </div>
    );
  }
}

DiscussionTopic.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  refetchQuery: PropTypes.func.isRequired,
};

export default DiscussionTopic;



// WEBPACK FOOTER //
// ./src/components/DiscussionTopic.jsx